export default "__VITE_ASSET__dee43f75__"